/* Ficha Ganga Shop V2 (11/10/2026, 12/10/2026). Lo carga sections/main-product.liquid con defer.
   - Envío (snippets/gs-envio.liquid): desde el 12/10 solo Montevideo y el retiro en el local, sin selector de zona.
   - "Te faltan $X para el envío gratis en Montevideo" (V2-15), con el precio de la variante elegida (o el total del kit).
   - WhatsApp (V2-12 y ficha agotada): el mensaje lleva la variante elegida y se cuenta el clic con
     Shopify.analytics.publish('gs_whatsapp_click').
   - Ficha agotada (V2-14): hasta 4 parecidos con stock y fuera de temporada (sections/gs-parecidos.liquid),
     con botón "Agregar" que usa el carrito del tema.
   - window.gsAgregar(items): agrega por el mismo camino que el tema (secciones del carrito, cartUpdate y cajón abierto).
     Lo usan los parecidos, "Llevalo con…" (snippets/gs-llevalo.liquid) y los selectores de kits (kit-selector-*).
   - "Llevalo con…": total de los dos con la variante elegida y "Agregar los dos" en un solo pedido.
   - Barra fija de los kits (snippets/sticky-atc-bar.liquid, data-gs-kit-bar): aparece cuando el botón del kit sale de
     pantalla, repite el kit elegido y su precio, y al tocarla dispara el botón real del kit (un solo camino de compra).
   Sin mediciones en el scroll. Los textos visibles salen del Liquid (data-*), acá solo se eligen. */
(function () {
  if (window.__gsFicha) return;
  window.__gsFicha = true;

  var carrito = null;

  function miles(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function plata(c) { return '$' + miles(Math.ceil(c / 100)); }
  function json(el, attr, fallback) { try { return JSON.parse(el.getAttribute(attr)); } catch (e) { return fallback; } }
  function rutas() { return (window.FoxTheme && FoxTheme.routes) || {}; }

  /* Variante elegida: se lee del formulario (el evento variant:changed informa la vieja). */
  function varianteId(sec) {
    var input = sec ? document.querySelector('#product-form-' + sec + ' [name="id"]') : null;
    if (!input) input = document.querySelector('product-info[id^="MainProduct"] form[is="product-form"] [name="id"]');
    return input ? String(input.value) : '';
  }

  /* ---------- "Te faltan $X para el envío gratis en Montevideo" (V2-15) ---------- */
  function resumir(c) {
    return {
      total: c.total_price || 0,
      items: c.item_count || 0,
      ids: (c.items || []).map(function (i) { return Number(i.variant_id); })
    };
  }

  function falta() {
    var box = document.querySelector('[data-gs-falta]');
    if (!box) return;
    var umbral = Number(box.getAttribute('data-umbral')) || 0;
    if (!umbral) return;
    if (!carrito) carrito = json(box, 'data-carrito', { total: 0, items: 0, ids: [] });
    var precios = json(box, 'data-precios', {});
    var vid = varianteId(box.getAttribute('data-section'));
    var precio = vid && precios[vid] ? precios[vid] : 0;
    /* si la variante ya está en el carrito, no se cuenta dos veces */
    var suma = precio > 0 && carrito.ids.indexOf(Number(vid)) === -1;
    /* en los kits no hay formulario del tema: cuenta el total del kit elegido */
    if (!vid) {
      precio = kitTotal();
      /* si alguna variante del kit (ids del JSON data-gks-data) ya está en el carrito, no se cuenta dos veces (QA 12/10) */
      var kd = document.querySelector('[data-gks] [data-gks-data]');
      var kitIds = ((kd && kd.textContent) || '').match(/\b\d{11,}\b/g) || [];
      kitIds = kitIds.concat(Object.keys(precios));
      var yaEsta = kitIds.some(function (k) { return k !== '0' && carrito.ids.indexOf(Number(k)) !== -1; });
      suma = precio > 0 && !yaEsta;
    }
    var base = carrito.total + (suma ? precio : 0);
    var resta = umbral - base;
    /* Emanuel 12/10: se ve siempre (antes solo con carrito o si faltaban $1.000 o menos) */
    var mostrar = true;
    box.hidden = !mostrar;
    if (!mostrar) return;
    var txt = box.querySelector('[data-gs-falta-txt]');
    if (txt) {
      if (resta > 0) {
        txt.innerHTML = (suma ? 'Con este, te faltan ' : 'Te faltan ') + '<strong>' + plata(resta) + '</strong> para el envío gratis en Montevideo';
      } else {
        txt.innerHTML = (suma ? 'Con este, tenés ' : 'Tenés ') + '<strong>envío gratis</strong> en Montevideo';
      }
    }
    var barra = box.querySelector('[data-gs-falta-barra]');
    if (barra) barra.style.width = Math.max(4, Math.min(100, Math.round((base * 100) / umbral))) + '%';
  }

  function refrescarCarrito() {
    fetch((rutas().cart_url || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (c) { carrito = resumir(c); falta(); })
      .catch(function () {});
  }

  /* ---------- WhatsApp: variante elegida en el mensaje y conteo del clic ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-gs-wa]') : null;
    if (!a) return;
    var num = a.getAttribute('data-gs-wa-num');
    var msg = a.getAttribute('data-gs-wa-msg') || '';
    var url = a.getAttribute('data-gs-wa-url') || '';
    var vid = a.getAttribute('data-gs-wa-variantes') === '1' ? varianteId(a.getAttribute('data-section')) : '';
    if (num && url) {
      a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg + ' ' + url + (vid ? '?variant=' + vid : ''));
    }
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('gs_whatsapp_click', {
          origen: a.getAttribute('data-gs-wa'),
          producto: a.getAttribute('data-gs-wa-handle') || '',
          variante: vid || ''
        });
      }
    } catch (err) {}
  });

  /* ---------- Ficha agotada: parecidos con stock (V2-14) ---------- */
  function tarjeta(p) {
    var art = document.createElement('div');
    art.className = 'gs-par';
    var link = document.createElement('a');
    link.className = 'gs-par__img';
    link.href = p.url;
    if (p.img) {
      var img = document.createElement('img');
      img.src = p.img;
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.width = 140;
      img.height = 140;
      link.appendChild(img);
    }
    art.appendChild(link);
    var tit = document.createElement('a');
    tit.className = 'gs-par__tit';
    tit.href = p.url;
    tit.textContent = p.title || '';
    art.appendChild(tit);
    var precio = document.createElement('span');
    precio.className = 'gs-par__precio';
    precio.textContent = plata(p.precio);
    art.appendChild(precio);
    var btn;
    if (p.variantes === 1) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gs-par__btn';
      btn.textContent = 'Agregar';
      btn.setAttribute('data-gs-par-add', p.vid);
    } else {
      btn = document.createElement('a');
      btn.className = 'gs-par__btn';
      btn.href = p.url;
      btn.textContent = 'Elegir';
    }
    art.appendChild(btn);
    return art;
  }

  /* ",a,b," para buscar handles enteros con indexOf */
  function lista(txt) { return ',' + String(txt || '').toLowerCase().replace(/\s+/g, '') + ','; }

  /* De temporada: está en alguna colección de la lista o es uno de los handles sueltos */
  function deTemporada(p, cols, sueltos) {
    if (sueltos.indexOf(',' + p.handle + ',') > -1) return true;
    var c = String(p.cols || '').split(',');
    for (var i = 0; i < c.length; i++) {
      if (c[i] && cols.indexOf(',' + c[i] + ',') > -1) return true;
    }
    return false;
  }

  function parecidos() {
    var box = document.querySelector('[data-gs-parecidos]');
    if (!box || box.getAttribute('data-gs-init')) return;
    box.setAttribute('data-gs-init', '1');
    var pid = box.getAttribute('data-product-id');
    var cols = lista(box.getAttribute('data-temporada'));
    var sueltos = lista(box.getAttribute('data-temporada-productos'));
    var root = rutas().root_url || '/';
    if (root.slice(-1) !== '/') root += '/';
    /* Sin parecidos se saca la fila (los lugares reservados): pasa poco, la red de seguridad es el aviso */
    function sacar() { box.hidden = true; box.removeAttribute('aria-busy'); }
    fetch(root + 'recommendations/products?product_id=' + pid + '&intent=related&limit=10&section_id=gs-parecidos', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-gs-parecidos-json[^>]*>([\s\S]*?)<\/script>/);
        var d = m ? JSON.parse(m[1]) : [];
        var elegidos = d.filter(function (p) {
          return p && p.vid && String(p.id) !== String(pid) && !deTemporada(p, cols, sueltos);
        }).slice(0, 4);
        if (!elegidos.length) { sacar(); return; }
        var fila = box.querySelector('[data-gs-parecidos-fila]');
        fila.textContent = '';
        elegidos.forEach(function (p) { fila.appendChild(tarjeta(p)); });
        box.classList.remove('is-cargando');
        box.removeAttribute('aria-busy');
      })
      .catch(sacar);
  }

  /* ---------- Agregar al carrito por el camino del tema ----------
     Pide las secciones del carrito, avisa con cartUpdate (contador, cajón, "Te faltan $X") y abre el cajón.
     items: [{id, quantity}]. Devuelve una promesa con el carrito; si Shopify no lo deja (sin stock), la rechaza. */
  function gsAgregar(items, foco) {
    var secciones = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: secciones } }));
    var R = rutas();
    var estado;
    return fetch((R.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: secciones, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        if (s && s.status) throw new Error(s.description || 'add');
        estado = s;
        return fetch((R.cart_url || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (c) {
        c.sections = estado && estado.sections;
        var P = window.FoxTheme && FoxTheme.pubsub;
        if (P && P.publish && P.PUB_SUB_EVENTS) P.publish(P.PUB_SUB_EVENTS.cartUpdate, { cart: c });
        else { carrito = resumir(c); falta(); }
        var cajon = document.querySelector('cart-drawer');
        if (cajon && typeof cajon.show === 'function') cajon.show(foco || null);
        else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        return c;
      });
  }
  window.gsAgregar = gsAgregar;

  /* Botón que agrega: estado "Agregado" o "No se pudo agregar" y vuelve a su texto */
  function agregarCon(btn, items, okClase) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    var texto = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    gsAgregar(items, btn)
      .then(function () {
        btn.classList.add(okClase);
        btn.textContent = 'Agregado';
        setTimeout(function () { btn.classList.remove(okClase); btn.textContent = texto; btn.removeAttribute('aria-disabled'); }, 2500);
      })
      .catch(function () {
        btn.textContent = 'No se pudo agregar';
        setTimeout(function () { btn.textContent = texto; btn.removeAttribute('aria-disabled'); }, 2500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gs-par-add]') : null;
    if (!btn) return;
    e.preventDefault();
    agregarCon(btn, [{ id: Number(btn.getAttribute('data-gs-par-add')), quantity: 1 }], 'gs-par__btn--ok');
  });

  /* ---------- "Llevalo con…" (snippets/gs-llevalo.liquid) ---------- */
  function llevalo() {
    document.querySelectorAll('[data-gs-llevalo]').forEach(function (box) {
      var precios = json(box, 'data-precios', {});
      var vid = varianteId(box.getAttribute('data-section'));
      var precio = vid && precios[vid] ? precios[vid] : 0;
      /* variante agotada: no hay "los dos" para ofrecer */
      box.hidden = !precio;
      if (!precio) return;
      var total = box.querySelector('[data-gs-llevalo-total]');
      if (total) total.textContent = plata(precio + (Number(box.getAttribute('data-comp-precio')) || 0));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-gs-llevalo-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('[data-gs-llevalo]');
    var vid = Number(varianteId(box && box.getAttribute('data-section')));
    var comp = Number(box && box.getAttribute('data-comp'));
    if (!vid || !comp) return;
    agregarCon(btn, [{ id: vid, quantity: 1 }, { id: comp, quantity: 1 }], 'gs-llevalo__btn--ok');
  });

  /* ---------- Kits: total elegido y barra fija ---------- */
  /* El botón del kit dice "Agregar al carrito · $990": el total sale de ahí (lo arma el selector de cada kit). */
  function kitTotal() {
    var el = document.querySelector('[data-gks] [data-gks-add-price]');
    var n = el ? Number(String(el.textContent).replace(/[^\d]/g, '')) : 0;
    return n > 0 ? n * 100 : 0;
  }

  function kitBarra() {
    var bar = document.querySelector('[data-gs-kit-bar]');
    var kit = document.querySelector('[data-gks]');
    var real = kit && kit.querySelector('[data-gks-add]');
    if (!bar || !real) return;
    var precioEl = bar.querySelector('[data-gs-kit-precio]');
    var nombreEl = bar.querySelector('[data-gs-kit-nombre]');
    var btn = bar.querySelector('[data-gs-kit-btn]');
    var btnTxt = btn && btn.querySelector('.btn__text');

    var ultimo = 0;
    function pintar() {
      /* mientras agrega ("Agregando...", "Agregado al carrito") el botón real no muestra precio: queda el último */
      var agregando = /Agreg[ao]/.test(real.textContent) && !/Agregar/.test(real.textContent);
      var total = kitTotal() || (agregando ? ultimo : 0);
      if (total) ultimo = total;
      var opt = kit.querySelector('.gks-opt.is-selected .gks-opt__title') || kit.querySelector('.gks-opt__input:checked ~ .gks-opt__body .gks-opt__title');
      if (precioEl) precioEl.textContent = total ? plata(total) : '';
      if (nombreEl) nombreEl.textContent = opt ? opt.textContent : '';
      if (btnTxt) btnTxt.textContent = real.disabled && !agregando ? 'Elegí tu kit' : 'Agregar al carrito';
      if (!agregando) falta();
    }
    pintar();
    /* el selector reescribe el precio del botón al elegir: se repinta con eso (sin medir nada) */
    new MutationObserver(pintar).observe(real, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });

    /* aparece cuando el botón del kit sale de pantalla (hacia arriba, o hacia abajo después del primer scroll) */
    var estado = { visible: true, arriba: false, scroll: false };
    function mostrar() {
      var si = !estado.visible && (estado.arriba || estado.scroll);
      bar.classList.toggle('sticky-atc-bar--show', si);
    }
    new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      estado.visible = en.isIntersecting;
      estado.arriba = !en.isIntersecting && en.boundingClientRect.bottom <= 0;
      mostrar();
    }, { threshold: 0 }).observe(real);
    window.addEventListener('scroll', function () { estado.scroll = true; mostrar(); }, { passive: true, once: true });

    /* un solo camino de compra: la barra toca el botón real; si falta elegir, lleva al selector */
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!real.disabled) { real.click(); return; }
      var destino = kit.querySelector('.gks__options') || kit;
      window.scrollTo({ top: destino.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
    });
  }

  /* ---------- Arranque ---------- */
  function iniciar() {
    falta();
    llevalo();
    var P = window.FoxTheme && FoxTheme.pubsub;
    if (P && P.subscribe && P.PUB_SUB_EVENTS) {
      P.subscribe(P.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        var c = ev && ev.cart;
        if (c && !c.errors && typeof c.total_price === 'number') { carrito = resumir(c); falta(); }
      });
      /* la barra fija y el precio se repintan con este mismo evento: se lee después */
      P.subscribe(P.PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { falta(); llevalo(); }, 0); });
    }
    /* el cross-sell agrega y avisa con cart:refresh (sin cartUpdate) */
    document.addEventListener('cart:refresh', function () { setTimeout(refrescarCarrito, 300); });
    /* volver con el botón atrás (bfcache) puede mostrar un carrito viejo */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refrescarCarrito(); });
    parecidos();
    kitBarra();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
